import { render, staticRenderFns } from "./ModalNPS.vue?vue&type=template&id=45e0b14a&scoped=true&"
import script from "./ModalNPS.vue?vue&type=script&lang=js&"
export * from "./ModalNPS.vue?vue&type=script&lang=js&"
import style0 from "./ModalNPS.vue?vue&type=style&index=0&id=45e0b14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0b14a",
  null
  
)

export default component.exports